import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@client/app/modules/translate.module';
import { MonEventTriggerModule } from '@monsido/angular-shared-components';
import { ForethoughtRunService } from '@client/app/modules/chat/forethought/run/forethought.run.service';
import { ForethoughtComponent } from '@client/app/modules/chat/forethought/components/icon/forethought.component';

export function initializeForethought (forethoughtRunService: ForethoughtRunService): () => Promise<void> {
    return () => Promise.resolve().then(() => {
        forethoughtRunService.setupEventListeners();
        return;
    });
}

@NgModule({
    declarations: [
        ForethoughtComponent,
    ],
    imports: [
        CommonModule,
        TranslateModule,
        MonEventTriggerModule,
    ],
    exports: [
        ForethoughtComponent,
    ],
    providers: [
        ForethoughtRunService,
        provideAppInitializer(() => {
            const initializerFn = (initializeForethought)(inject(ForethoughtRunService));
            return initializerFn();
        }),
    ],
})
export class ForethoughtModule { }
